import React, { useRef, useState } from 'react';
import { Icon } from '../../UI';
import { PopperComponent } from '../../UI';
import { useOutsideClick } from '../../../hooks/useOutsideClick';

type RenderPropParams = {
  setVisible: React.Dispatch<React.SetStateAction<boolean>>;
};

interface BurgerMenuProps {
  children: ({ setVisible }: RenderPropParams) => React.ReactNode;
}

export const BurgerMenu: React.FC<BurgerMenuProps> = ({ children }) => {
  const [visible, setVisible] = useState(false);
  const containerRef = useRef<HTMLDivElement | null>(null);

  const toggleMenu = () => setVisible((prev) => !prev);
  useOutsideClick(containerRef, () => setVisible(false));

  return (
    <div ref={containerRef} className={'h-full lg:hidden'}>
      <PopperComponent
        options={{
          modifiers: [
            {
              name: 'offset',
              options: { offset: [0, 0] },
            },
          ],
        }}
        referenceClassName={'h-full flex items-center'}
        contentClassName={
          'w-full bg-white border-t dark:bg-grey-90 dark:border-grey-70 border-grey-10 shadow-md'
        }
        reference={
          <Icon
            svgName={'burgerMenu'}
            className={`w-5 h-5 cursor-pointer`}
            onClick={toggleMenu}
          />
        }
        visible={visible}
      >
        {children({ setVisible })}
      </PopperComponent>
    </div>
  );
};
